export default "__VITE_ASSET__RJ9fNnT3__"